import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormHelpersService {

  /**
   * Check if a form field is invalid and has been touched
   */
  isFieldInvalid(form: FormGroup, fieldName: string): boolean {
    const field = form.get(fieldName);
    return field ? field.invalid && field.touched : false;
  }

  /**
   * Get a user-friendly error message for a form field
   */
  getFieldError(form: FormGroup, fieldName: string): string {
    const field = form.get(fieldName);
    if (field?.errors) {
      if (field.errors['required']) return `${this.formatFieldName(fieldName)} is required.`;
      if (field.errors['minlength']) return `${this.formatFieldName(fieldName)} must be at least ${field.errors['minlength'].requiredLength} characters.`;
      if (field.errors['maxlength']) return `${this.formatFieldName(fieldName)} must be no more than ${field.errors['maxlength'].requiredLength} characters.`;
      if (field.errors['email']) return `Please enter a valid email address.`;
      if (field.errors['pattern']) return `Please enter a valid ${this.formatFieldName(fieldName)}.`;
    }
    return '';
  }

  /**
   * Format field name for better error messages
   */
  private formatFieldName(fieldName: string): string {
    return fieldName
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  }
}
